<template>
  <div class="view-container">
  <PageHeader title="ثبت نوبت" subtitle="" :infoLearnUrl="infoLearnUrl" infoTitle="راهنمای ثبت نوبت">
    <template #info>
      <p style="line-height:1.9; white-space:pre-line;">
        جهت مشاهده نوبت های هر روز تاریخ مد نظر را انتخاب نمایید، برای مشاهده این صفحه در تابلو اعلانات روی دکمه تمام صفحه کلیک کنید همچنین با استفاده از دکمه فیلتر پزشکان میتوانید نوبت های ثبت شده برای پزشک و اپراتون مد نظر را مشاهده نمایید.
        
        جهت مشاهده فیلم و راهنمای کامل آموزشی بر روی لینک زیر کلیک نمایید.
      </p>
    </template>
  </PageHeader>
    <div class="receptions-container">
      <div class="sub-header">
        <h2 class="page-title">لیست نوبت</h2>
        <div class="header-buttons">
          <BaseButton title="ایجاد نوبت" variant="primary" type="button" v-if="appointmentMode == 'table'" @click="openBatchModal" id="responsive-style" />
          <BaseButton title="جدید" variant="primary" type="button" v-if="appointmentMode == 'single'" @click="openModal" id="responsive-style" />
        </div>
      </div>
      <hr class="divider-line" />
      <div class="bottom-header">
        <div class="form-group">
          <label>فیلتر بر اساس تاریخ</label>
          <span class="custom-date">
            <div class="p-date" style="width: 100% !important; border: none !important">
              <DatePicker v-model="selectedDate" format="jYYYY/jMM/jDD" display-format="jYYYY/jMM/jDD" :editable="true"
                auto-submit @change="onDateChange" placeholder="همه تاریخ‌ها" />
            </div>
            <!-- دکمه فقط وقتی نمایش داده می‌شود که selectedDate مقدار داشته باشد -->
            <BaseButton v-if="selectedDate" title="×" variant="danger" type="button" @click="clearDateFilter" class="clear-date-btn" />
          </span>
        </div>

        <div class="search">
          <div class="form-group">
            <label></label>
            <input id="general-search" type="text" v-model="searchQuery"
              placeholder="جستجو براساس نام بیمار، کد ملی، موبایل..." />
          </div>
          <BaseButton title="جستجو" variant="primary" type="button" @click="searchClick()" />
        </div>
      </div>

      <div class="table-wrapper">
        <Teleport to="body">
          <div v-if="floatingTooltip.visible" class="floating-tooltip" :style="{ left: floatingTooltip.left + 'px', top: floatingTooltip.top + 'px' }">{{ floatingTooltip.text }}</div>
        </Teleport>
        <BaseTable
          :items="receptionsList"
          :empty-colspan="14"
        >
          <template #empty>
            هیچ اطلاعاتی یافت نشد.
          </template>

          <template #head>
            <tr>
              <th>ردیف</th>
              <th>نوبت</th>
              <th>تاریخ نوبت</th>
              <th>ساعت حضور</th>
              <th>نام و نام خانوادگی بیمار</th>
              <th>نام و نام خانوادگی پزشک</th>
              <th>شماره پرونده</th>
              <th>کد ملی</th>
              <th>سن</th>
              <th>تلفن همراه</th>
              <th>تلفن ثابت</th>
              <th>نوع بیمه</th>
              <!-- <th>شماره بیمه</th> -->
              <th>توضیحات</th>
              <th>عملیات</th>
            </tr>
          </template>

          <template #row="{ item: reception, index }">
            <td data-label="ردیف">
              {{
                toPersianDigits(
                  (pagination.current_page - 1) * pagination.per_page +
                  index +
                  1
                )
              }}
            </td>
            <td data-label="نوبت">{{ toPersianDigits(reception.fRnumber) }}</td>
            <td data-label="تاریخ نوبت">{{ toPersianDigits(reception.fRdate) }}</td>
            <td data-label="ساعت حضور">{{ toPersianDigits(reception.fRtime) }}</td>
            <td data-label="نام و نام خانوادگی بیمار">{{ reception.fNamefami }}</td>
            <td data-label="نام و نام خانوادگی پزشک">{{ reception.fDname }}</td>
            <td data-label="شماره پرونده">{{ toPersianDigits(reception.fParno) }}</td>
            <td data-label="کد ملی">{{ toPersianDigits(reception.pmeli) }}</td>
            <td data-label="سن">{{ toPersianDigits(reception.fAge) }}</td>
            <td data-label="تلفن همراه">{{ toPersianDigits(reception.ptele) }}</td>
            <td data-label="تلفن ثابت">{{ toPersianDigits(reception.fTdesc2) }}</td>
            <td data-label="نوع بیمه">{{ reception.fBdesc }}</td>
            <td data-label="توضیحات">{{ reception.fRdescription }}</td>
            <td class="actions-cell" data-label="عملیات">
              <BaseButton
                title=""
                hint="ویرایش"
                icon="/img/edit.svg"
                icon-alt="ویرایش"
                variant="ghost"
                shape="circle"
                type="button"
                aria-label="ویرایش"
                @click="handleEdit(reception)"
                @mouseenter.stop="showFloatingTooltip($event,'ویرایش')"
                @mouseleave.stop="hideFloatingTooltip()"
                @focus.stop="showFloatingTooltip($event,'ویرایش')"
                @blur.stop="hideFloatingTooltip()"
              />
              {{ reception.frid }}
              <BaseButton
                title=""
                hint="حذف"
                icon="/img/trash.svg"
                icon-alt="حذف"
                variant="ghost"
                shape="circle"
                type="button"
                aria-label="حذف"
                @click="clearReception(reception.fRid, index)"
                @mouseenter.stop="showFloatingTooltip($event,'حذف')"
                @mouseleave.stop="hideFloatingTooltip()"
                @focus.stop="showFloatingTooltip($event,'حذف')"
                @blur.stop="hideFloatingTooltip()"
              />
            </td>
          </template>
        </BaseTable>
      </div>
      <PaginationPart :pagination="pagination" @page-change="fetchReceptions" />
    </div>

  <div v-if="isModalOpen" class="modal-overlay center-modal-overlay">
      <div class="modal-content">
        <div v-if="modalView === 'form'">
          <div class="modal-sub-header">
            <div class="sub-header">
              <ModalHeader>
                <template #default>
                  <h2 class="page-title">افزودن نوبت جدید</h2>
                </template>
              </ModalHeader>
              <div class="form-actions">
                <BaseButton title="ثبت اطلاعات" variant="primary" type="submit" form="reception-form" style="margin-left: 10px;" id="responsive-style" />
                <BaseButton title="انصراف" variant="cancel" @click="closeModal" id="responsive-style" />
              </div>
            </div>
            <hr class="divider-line" />
          </div>
          <form @submit.prevent="handleSubmit" class="reception-form-container" id="reception-form">
            <div class="top-form-fields">
              <div class="form-group">
                <label for="reception-date">تاریخ پذیرش<span class="required">*</span></label>
                <div class="p-date">
                  <DatePicker v-model="receptionForm.fRdate" format="jYYYY/jMM/jDD" display-format="jYYYY/jMM/jDD"
                    placeholder="تاریخ را وارد یا انتخاب کنید" :editable="true" auto-submit
                    :disabled="formMode === 'edit'" />
                </div>
              </div>
              <div class="form-group">
                <label for="doctor-name">نام و نام خانوادگی پزشک
                  <span class="required">*</span></label>
                <GenericSelect key="doctor-select" v-model="receptionForm.fRdocid" entity-type="doctor"
                  :store="doctorsComboStore" label-field="fDname" value-field="fDauto" secondary-field="fDnezamno"
                  placeholder="جستجو بر اساس نام، تخصص، نظام پزشکی..." :enable-enter-search="true"
                  :refetch-on-clear="true" :enable-infinite-scroll="false" @item-selected="onDoctorSelected"
                  @search="onDoctorSearch" @clear="onDoctorClear">
                  <template #option="{ fDname, fDtakhasos, fDnezamno, fDauto }">
                    <div class="doctor-option">
                      <div class="doctor-main">
                        <strong>{{ fDname }}</strong>
                        <span class="specialty">تخصص: {{ fDtakhasos }}</span>
                      </div>
                      <div class="doctor-secondary">
                        <span v-if="fDnezamno" class="medical-code">نظام پزشکی: {{ fDnezamno }}</span>
                        <span class="doctor-id">ID: {{ fDauto }}</span>
                      </div>
                    </div>
                  </template>
                </GenericSelect>
              </div>
              <div class="form-group">
                <label for="patient-name">انتخاب بیمار
                  <span class="required">*</span></label>
                <GenericSelect key="patient-select" v-model="receptionForm.fRprsid" entity-type="patient"
                  :store="patientsComboStore" label-field="fFami" value-field="fTauto" secondary-field="pmeli"
                  placeholder="جستجو بر اساس نام، نام خانوادگی، کدملی..." :enable-enter-search="true"
                  :refetch-on-clear="true" :enable-infinite-scroll="false" @item-selected="onPatientSelected"
                  @search="onPatientSearch" @clear="onPatientClear">
                  <template #option="{ fFami, fTname, pmeli, fParno }">
                    <div class="patient-option">
                      <div class="patient-main">
                        <strong>{{ fFami }} {{ fTname }}</strong>
                        <span class="file-number">پرونده: {{ fParno }}</span>
                      </div>
                      <div class="patient-secondary">
                        <span v-if="pmeli" class="national-code">کدملی: {{ pmeli }}</span>
                      </div>
                    </div>
                  </template>
                </GenericSelect>
              </div>
            </div>
            <div class="bottom-form-fields">
              <div class="form-group span-4">
                <label for="visit-time">ساعت حضور</label>
                <div class="p-date">
                  <date-picker v-model="receptionForm.fRtime" type="time" format="HH:mm" display-format="HH:mm"
                    :editable="true" />
                </div>
              </div>
              <div class="form-group">
                <label for="visit-number">نوبت</label>
                <input id="visit-number" type="number" v-model="receptionForm.fRnumber" />
              </div>
            </div>
            <div class="form-group span-4">
              <label>توضیحات</label>
              <textarea v-model="receptionForm.fRdescription" rows="3"></textarea>
            </div>
          </form>
        </div>
        <div v-if="modalView === 'batch-create'" class="selection-view">
          <div class="modal-sub-header">
            <div class="sub-header">
              <ModalHeader>
                <template #default>
                  <h2 class="page-title">ایجاد لیست نوبت</h2>
                </template>
              </ModalHeader>
              <div class="form-actions">
                <BaseButton title="ثبت نوبت‌ها" variant="primary" type="button" @click="handleBatchSubmit" style="margin-left: 10px;" id="responsive-style" />
                <BaseButton title="انصراف" variant="cancel" @click="closeModal" id="responsive-style" />
              </div>
            </div>

            <hr class="divider-line" />
          </div>
          <form @submit.prevent="handleBatchSubmit" class="batch-form">
            <div class="form-group">
              <label>نام پزشک</label>
              <GenericSelect key="doctor-select" v-model="batchForm.doctorId" entity-type="doctor"
                :store="doctorsComboStore" label-field="fDname" value-field="fDauto" secondary-field="fDnezamno"
                placeholder="جستجو بر اساس نام، تخصص، نظام پزشکی..." :enable-enter-search="true"
                :refetch-on-clear="true" :enable-infinite-scroll="false" @item-selected="onDoctorSelected"
                @search="onDoctorSearch" @clear="onDoctorClear">
                <template #option="{ fDname, fDtakhasos, fDnezamno, fDauto }">
                  <div class="doctor-option">
                    <div class="doctor-main">
                      <strong>{{ fDname }}</strong>
                      <span class="specialty">تخصص: {{ fDtakhasos }}</span>
                    </div>
                    <div class="doctor-secondary">
                      <span v-if="fDnezamno" class="medical-code">نظام پزشکی: {{ fDnezamno }}</span>
                      <span class="doctor-id">ID: {{ fDauto }}</span>
                    </div>
                  </div>
                </template>
              </GenericSelect>
            </div>
            <div class="form-group">
              <label for="start-date">از تاریخ<span class="required">*</span></label>
              <div class="p-date">
                <DatePicker v-model="batchForm.startDate" format="jYYYY/jMM/jDD" display-format="jYYYY/jMM/jDD"
                  placeholder="تاریخ را وارد یا انتخاب کنید" :editable="true" auto-submit
                  :disabled="formMode === 'edit'" />
              </div>
            </div>
            <div class="form-group">
              <label for="end-date">تا تاریخ<span class="required">*</span></label>
              <div class="p-date">
                <DatePicker v-model="batchForm.endDate" format="jYYYY/jMM/jDD" display-format="jYYYY/jMM/jDD"
                  placeholder="تاریخ را وارد یا انتخاب کنید" :editable="true" auto-submit
                  :disabled="formMode === 'edit'" />
              </div>
            </div>
            <div class="form-group">
              <label for="appt-count">تعداد نوبت</label>
              <input id="appt-count" type="number" v-model.number="batchForm.count" />
            </div>
            <div class="form-group">
              <label for="start-time">ساعت حضور</label>
              <div class="p-date">
                <date-picker v-model="batchForm.startTime" type="time" format="HH:mm" display-format="HH:mm"
                  :editable="true" />
              </div>
            </div>
            <div class="form-group">
              <label for="end-time">ساعت خروج</label>
              <div class="p-date">
                <date-picker v-model="batchForm.endTime" type="time" format="HH:mm" display-format="HH:mm"
                  :editable="true" />
              </div>
            </div>
            <div class="form-group">
              <label for="end-time">مدت انتظار (دقیقه)</label>
              <div class="p-date">
                <date-picker v-model="batchForm.interval" type="time" format="HH:mm" display-format="HH:mm"
                  :editable="true" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- Global ConfirmModal is provided by App.vue and used via useConfirm() -->
  <!-- Info is handled by PageHeader -->
</template>

<script setup>
import BaseTable from '@/components/UiCompunents/BaseTable.vue'
import PageHeader from '@/components/PageHeader.vue';
/* eslint-disable vue/multi-word-component-names */
import { ref, reactive, computed, onMounted, watch } from "vue";
import { useFloatingTooltip } from '@/composables/useFloatingTooltip'
const { floatingTooltip, showFloatingTooltip, hideFloatingTooltip } = useFloatingTooltip()
import DatePicker from "vue3-persian-datetime-picker";
import moment from "jalali-moment";
import { storeToRefs } from "pinia";
import { toPersianDigits } from '@/utils/formatters.js';
import { usePatientsStore } from "@/stores/clinic/patients.js";
import PatientForm from "@/components/patients/PatientForm.vue";
import { useDoctorsStore } from "@/stores/clinic/doctors.js";
import { useReceptionsStore } from "@/stores/clinic/receptions.js";
import PaginationPart from "@/components/PaginationPart.vue";
import ModalHeader from '@/components/ModalHeader.vue'
import BaseButton from '@/components/UiCompunents/BaseButton.vue'
import GenericSelect from "@/components/generic-select.vue";
import { usePatientsComboStore } from '@/stores/VueSelectStores/patientsCombo';
import { useDoctorsComboStore } from '@/stores/VueSelectStores/doctorsCombo';
import { useToast } from "vue-toastification";
import { useSettingStore } from "@/stores/clinic/setting";
import { useConfirm } from '@/stores/composables.js'

// --- LOCAL UI STATE ---
const isModalOpen = ref(false);
const { confirm } = useConfirm();
const appointmentMode = ref(null)

const modalView = ref("form");
const formMode = ref("add");
const editingReceptionId = ref(null);
const doctors = ref([]);
const toast = useToast();
const settingStore = useSettingStore();
const { fetchSetting } = settingStore;
// Info modal link
const infoLearnUrl = 'https://www.sinapardazesh.ir/matab-learning-web/';

// --- FORM STATE ---
const batchForm = reactive({
  doctorId: null,
  count: 10,
  startTime: "09:00",
  endTime: "17:00",
  interval: "10:00",
  startDate: moment().format("jYYYY/jMM/jDD"),
  endDate: moment().format("jYYYY/jMM/jDD"),
});
const initialFormState = {
  fRdate: ref(moment().format("jYYYY/jMM/jDD")),
  fRdocid: null,
  fRprsid: null,
  fRnumber: 0,
  fRtime: "",
  fRdescription: "",
};
let receptionForm = reactive({ ...initialFormState });

// --- STORE SETUP ---
const patientsComboStore = usePatientsComboStore();
const doctorsComboStore = useDoctorsComboStore();
const receptionsStore = useReceptionsStore();
const { receptionsList, pagination, searchQuery, filters, searchColumn } =
  storeToRefs(receptionsStore);
const {
  addReception,
  updateReception,
  deleteReception,
  batchAddReceptions,
  fetchReceptions,
} = receptionsStore;

// --- COMPUTED & WATCHERS ---

// --- patient ---
const onPatientSelected = (patient) => {
  if (patient) {
    receptionForm.fRprsid = patient.fTauto;
  }
};

const onPatientSearch = (query) => {
};

const onPatientClear = () => {
  receptionForm.fRprsid = null;
};

// --- doctor ---
const onDoctorSelected = (doctor) => {
  if (doctor) {
    receptionForm.fRdocid = doctor.fDauto;
  }
};

const onDoctorSearch = (query) => {
};

const onDoctorClear = () => {
  receptionForm.fRdocid = null;
};

// --- METHODS ---
function resetForm() {
  Object.assign(receptionForm, initialFormState);
}

// centralized toPersianDigits from utils/formatters
const selectedDate = ref(moment().format("jYYYY/jMM/jDD")); // تاریخ امروز
function onDateChange() {
  filters.value = [{ column: "F_rdate", operator: "=", value: selectedDate.value }]
  fetchReceptions(pagination.value.current_page);
}

function clearDateFilter() {
  selectedDate.value = ""; // مقدار خالی یعنی همه تاریخ‌ها
  filters.value = []
  fetchReceptions(pagination.value.current_page); // بارگذاری مجدد جدول
}
function searchClick() {
  fetchReceptions(pagination.value.current_page); // بارگذاری مجدد جدول
}
function openModal() {
  formMode.value = "add";
  resetForm();
  modalView.value = "form";
  isModalOpen.value = true;
}
function openBatchModal() {
  batchForm.doctorId = null;
  modalView.value = "batch-create";
  isModalOpen.value = true;
}
function closeModal() {
  isModalOpen.value = false;
}
// closeDeleteModal removed: using global confirm modal instead

// Info modal now handled by PageHeader; openInfoModal removed

// closeInfoModal is handled by InfoModal via v-model

async function handleBatchSubmit() {
  const payload = {
    count: batchForm.count,
    startTime: batchForm.startTime,
    endTime: batchForm.endTime,
    interval: batchForm.interval,
    fromDate: batchForm.startDate,
    toDate: batchForm.endDate,
    doctorId: batchForm.doctorId
  };

  await batchAddReceptions(payload);
  closeModal();
}
async function handleSubmit() {
  let success = false;

  if (formMode.value === "add") {
    // The store action now handles all alerts and returns true/false
    success = await addReception({ ...receptionForm });
  } else {
    success = await updateReception({ ...receptionForm });
  }

  // Only close the modal if the action was successful
  if (success) {
    closeModal();
    resetForm();
  }
}

async function handleEdit(reception) {
  try {
    formMode.value = "edit";
    editingReceptionId.value = reception.frid;

    // پر کردن فوری فرم
    const dataForForm = { ...reception };

    Object.assign(receptionForm, dataForForm);

    modalView.value = "form";
    isModalOpen.value = true;

    setTimeout(() => {
      loadComboData();
    }, 50);

  } catch (error) {
    console.error('Error in handleEdit:', error);
    toast.error('خطا در بارگذاری اطلاعات ویرایش');
  }
}
// تابع جداگانه برای لود داده‌های combo
async function loadComboData() {
  try {
    await Promise.all([
      doctorsComboStore.loadInitialData(),
      patientsComboStore.loadInitialData()
    ]);
    console.log('Combo data loaded successfully');
  } catch (error) {
    console.warn('Combo data loading failed, but form is still functional:', error);
  }
}
async function clearReception(recordId, index) {
  const confirmed = await confirm({
    title: 'حذف نوبت',
    message: 'آیا از حذف این رکورد اطمینان دارید؟',
    confirmText: 'بله، حذف شود',
    cancelText: 'انصراف'
  })
  if (!confirmed) return;
  try {
    await deleteReception(recordId);
    // Remove item from local array (if available)
    if (receptionsList.value && Array.isArray(receptionsList.value)) {
      const foundIndex = receptionsList.value.findIndex(r => r.fRid === recordId);
      if (foundIndex > -1) receptionsList.value.splice(foundIndex, 1);
    }
    toast.success('نوبت با موفقیت حذف شد')
  } catch (error) {
    console.error("Error deleting reception:", error);
    toast.error("خطا در حذف");
  }
}
onMounted(async () => {
  await initializePage();
});

async function initializePage() {
  try {
    filters.value = [{ column: "F_rdate", operator: "=", value: selectedDate.value }]
    fetchReceptions(pagination.value.current_page);

    const cashSetting = await fetchSetting();
    if (!cashSetting) {
      toast.error("برای شما تنظیماتی وجود ندارد، لطفا تنظیمات را اعمال نمایید")
      return;
    }

    const printSettings = JSON.parse(cashSetting.printSettings);
    if (printSettings?.appointmentMode) {
      appointmentMode.value = printSettings.appointmentMode;
    }
  } catch (error) {
    console.error("Error initializing page:", error);
    toast.error("خطا در بارگذاری تنظیمات");
  }
}
</script>
<style scoped>
/* NOTE: The styles below have been updated to use theme CSS variables
  (see `src/assets/Style.scss`) so search, date-picker and table
  components follow the active theme (light/dark/gray). New variables
  have sensible fallbacks to preserve previous look when not defined.
*/
.view-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
}

.header {
  width: 100%;
  text-align: right;
  color: var(--text-color-primary);
  padding: 10px;

  border-radius: 20px;
}

.info-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  vertical-align: middle;
  margin-right: 4px;
  margin-left: 4px;
  z-index: 2;
  cursor: pointer;
}
.modal-sub-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: var(--background-color);
  gap: 10px;
  z-index: 99;
  padding-top: 20px;
}

.sub-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: var(--text-color-secondary);
  width: 100% !important;
}

.header-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  .batch-add-btn {
    display: flex;
    align-items: center;
    padding: 10px 22px;
    border-radius: 10px;
    border: none;
    cursor: pointer;
    background-color: var(--background-color-button);
    color: var(--background-color);

    &:hover {
      background-color: var(--background-color-button-hover);
    }
  }

  .add {
    display: flex;
    align-items: center;
    padding: 10px 22px;
    border-radius: 10px;
    border: none;
    cursor: pointer;
    background-color: var(--background-color-button);
    color: var(--background-color);

    &:hover {
      background-color: var(--background-color-button-hover);
    }
  }
}

.bottom-header {
  display: flex;
  align-items: end;
  gap: 10px;
}

.search {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
}

.search>.form-group {
  flex: 1;
}

.clear-date-btn {
  border-radius: 30%;
  padding: 5px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  margin-left: 5px;
  /* Follow theme danger color if provided */
  background-color: var(--danger-color, #ff0f0f);
  color: var(--text-on-danger, #ffffff);
}

.custom-date {
  display: flex;
  align-items: center;
  gap: 2px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  background-color: var(--background-color) !important;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.receptions-container {
  direction: rtl;
  padding: 25px;
  background-color: var(--background-color);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 40px;
  max-height: 100vh;
}

/* The main form container is now a flexbox column */
.patient-form-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* Gap between top and bottom sections */
}

/* --- New styles for the top section layout --- */
.top-section {
  display: flex;
  gap: 20px;
  align-items: stretch;
  /* Makes children have equal height */
}

.top-form-fields {
  flex: 6;
  /* Takes up 3 parts of the space (wider) */
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

/* --- End of new styles --- */

.top-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.bottom-form-fields {
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 20px;
}

.batch-form {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 5px;
  color: var(--tex-color-thirdly);
  text-align: justify;
}

.required {
  color: var(--danger-color, #ff0f0f);
  margin-right: 4px;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 5px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: start;
  width: 100%;
  background-color: var(--background-color-secondary);
  color: var(--text-color-primary);
}

.form-group input,
.form-group select {
  height: 34px;
}

input#doctor-name {
  border: none;
  border-radius: 0;
  height: 34px;
}

input#patient-name {
  border: none;
  border-radius: 0;
  height: 34px;
}

.custom-input {
  display: flex;
  align-items: center;
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: start;
  overflow: hidden;
}

.icon {
  background-color: var(--text-color-secondary) !important;
  color: #ffffff;
  padding: 10px;
  width: auto;
  height: 14px;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--text-color-primary);
}

.form-actions {
  display: flex;
  justify-content: flex-start;
}

.p-date {
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: start;
  overflow: hidden;
  background-color: var(--background-color);
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.p-date :deep(.vpd-container) {
  border: 1px solid rgba(var(--text-color-secondary-rgb), 0.12);
  border-radius: 0.75rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  background-color: var(--background-color);
}

.p-date :deep(.vpd-input-group label) {
  background-color: var(--background-color-button) !important;
}

.p-date :deep(.vpd-input-group input) {
  border: none !important;
  line-height: 32px !important;
  background-color: var(--background-color) !important;
  color: var(--text-color-primary) !important;
}

.p-date :deep(.vpd-input-group input::placeholder) {
  color: var(--text-color-secondary) !important;
  opacity: 1;
}

.p-date :deep(.vpd-input-group input:focus) {
  border: 1px solid transparent !important;
}

.p-date :deep(.vpd-icon-btn),
.p-date :deep(button.vpd-icon-btn),
.p-date :deep(.vpd-actions button) {
  background-color: var(--background-color-button) !important;
  color: var(--background-color) !important;
  transition: background-color 0.3s ease !important;
}

.p-date :deep(.vpd-icon-btn svg),
.p-date :deep(button.vpd-icon-btn svg),
.p-date :deep(.vpd-actions button svg),
.p-date :deep(.vpd-icon-btn svg path),
.p-date :deep(button.vpd-icon-btn svg path),
.p-date :deep(.vpd-actions button svg path) {
  fill: var(--background-color) !important;
  color: var(--background-color) !important;
  stroke: var(--background-color) !important;
}

.p-date :deep(.vpd-icon-btn:hover),
.p-date :deep(button.vpd-icon-btn:hover),
.p-date :deep(.vpd-actions button:hover) {
  background-color: var(--background-color-button-hover) !important;
}

  /* submit-button replaced by BaseButton (variant="primary") */

input#general-search {
  width: auto;
  flex: 1;
  padding: 6px 8px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: start;
  background-color: var(--background-color);
  color: var(--text-color-primary);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

/* More specific rules to ensure the search input follows the active theme
   and is not overridden by other selectors or global styles. We use
   !important as a last-resort to match existing project specificity. */
.search input#general-search,
.search > .form-group input#general-search,
.search-with-button input#general-search {
  background-color: var(--background-color) !important;
  color: var(--text-color-primary) !important;
  border-color: var(--text-color-secondary) !important;
}

.search input#general-search:focus,
.search-with-button input#general-search:focus {
  outline: none;
  border-color: var(--text-color-primary) !important;
  box-shadow: 0 0 0 2px rgba(var(--background-color-button-rgb), 0.12);
}

input#general-search::placeholder {
  color: var(--text-color-secondary) !important;
  opacity: 1;
}

/* .search-button removed — replaced with BaseButton (variant="primary") */

.empty-row td {
  text-align: center;
  padding: 40px;
  color: var(--text-color-secondary);
}

.actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

/* Inline tooltip CSS removed — floating tooltip used instead */

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background-color: rgba(var(--text-color-secondary-rgb), 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  -webkit-backdrop-filter: saturate(180%) blur(5px) !important;
  backdrop-filter: saturate(180%) blur(5px) !important;
}

.modal-content {
  background-color: var(--background-color);
  padding: 0 20px 20px 20px;
  border-radius: 30px;
  width: auto;
  max-height: 90vh;
  max-width: 90vw;
  overflow-y: auto;
  position: relative;
  direction: rtl;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px;
}

/* Specific styling for the header info modal (do not affect other modals) */
.info-modal-content {
  width: auto;
  max-width: 720px;
  min-width: 320px;
  height: auto;
  max-height: 80vh;
  border-radius: 12px;
  padding: 18px 20px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.12);
}
.info-modal-content .modal-sub-header { padding-top: 8px; }
.info-modal-content .modal-body { padding: 6px 2px 12px 2px; overflow-y:auto; }
.info-modal-content .modal-body p { font-size: 18px; line-height: 1.9; text-align: justify; direction: rtl; text-justify: inter-word; }
@media (max-width: 480px) {
  .info-modal-content .modal-body p { font-size: 16px; }
}

/* Ensure the info modal becomes a bottom sheet on mobile */
@media (max-width: 768px) {
  .info-modal-overlay { align-items: flex-end !important; padding: 0 12px 12px !important; }
  .info-modal-content { width: 100% !important; max-width: 100% !important; margin: 0 !important; border-radius: 12px 12px 0 0 !important; padding: 12px !important; box-shadow: 0 -6px 30px rgba(0,0,0,0.12) !important; transform: none !important; }
  .center-modal-overlay { align-items: center !important; padding: 12px !important; }
}

.modal-close-btn {
  border: none;
  font-size: calc(0.3vw + 12px);
  color: var(--text-color-secondary);
  background-color: transparent;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.selection-view {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 300px;
}

input.selection-search-input {
  width: 100%;
  padding: 6px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: start;
  background-color: var(--background-color-input, transparent);
}

.selection-table-wrapper {
  overflow: auto;
  max-height: 70vh;
  border: 1px solid var(--box-border-color, var(--tex-color-thirdly)) !important;
  border-radius: 10px;
}

.selection-table {
  width: 100%;
  text-align: right;
  font-size: calc(0.3vw + 8px);
  color: var(--text-color-primary);
  border-collapse: separate;
  border-spacing: 0;
}

.selection-table th,
.selection-table td {
  padding: 12px 15px;
  border-bottom: 1px solid var(--table-border-color, #e5e7eb);
  white-space: nowrap;
}

.selection-table th {
  position: sticky;
  top: 0;
  z-index: 2;
  font-weight: bold;
  border-left: 1px solid var(--table-border-color, #e5e7eb);
}

.selection-table td {
  border-left: 1px solid var(--table-border-color, #e5e7eb);
}

.selection-table tbody tr {
  cursor: pointer;
}

.selection-table tbody tr.selected-row {
  background-color: var(--hover-background-color);
  /* A light blue color for highlighting */
  color: var(--background-color-button, #1476f3);
  font-weight: bold;
}

.form-actions-inline {
  display: flex;
  gap: 10px;
  align-items: center;

  justify-content: end;
}

.add-button-inline {
  display: flex;
  align-items: center;
  padding: 7px 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  background-color: var(--text-color-primary);
  color: var(--background-color);
  text-wrap-mode: nowrap;
}

.select-btn:disabled {
  /* --- Styles for when the button is DISABLED (no row is selected) --- */
  background-color: var(--text-color-secondary, #9ca3af);
  /* Gray background */
  color: #ffffff;
  cursor: not-allowed;
  opacity: 0.6;
  /* Make it look faded */
}




@media (max-width: 768px) {
  .receptions-container {
    margin-bottom: 0 !important;
  }

  .bottom-header {
    flex-direction: column !important;
    align-items: flex-start !important;
  }

  .form-group {
    width: 100% !important;
  }

  .add {
    padding: 5px 18px !important;
  }

  .top-section {
    flex-direction: column;
    /* Stack image area on top of fields */
  }

  .top-form-fields,
  .bottom-form-fields {
    grid-template-columns: 1fr;
  }

  .form-group.span-4 {
    grid-column: span 1;
  }

  .image-upload-area {
    min-height: 200px;
  }

  .batch-form {
    grid-template-columns: repeat(1, 1fr) !important;
  }

  .batch-add-btn {
    padding: 5px 18px !important;
  }

  /* mobile override for .submit-button removed — use BaseButton (variant="primary") */

  /* Special styling for the actions cell */
  .actions-cell {
    justify-content: center;
    /* Center the buttons */
  }

  /* Inline tooltip CSS removed - floating tooltip used instead */

  .modal-overlay {
    align-items: end !important;
  }

  .modal-content {
    max-width: 95vw !important;
    width: 100% !important;
    max-height: 80vh !important;
    padding: 0 10px 10px 10px !important;
    border-radius: 20px 20px 0 0 !important;
    margin: 0 !important;
  }

  .modal-sub-header {
    padding-top: 10px !important;
  }

  .selection-table-wrapper {
    overflow: auto;
    /* Enables both horizontal and vertical scrolling */
    /*min-height: 100vh !important;*/
    border: none !important;
    border-radius: 0px;
  }

  .selection-table thead {
    /* 1. Hide the table header on mobile */
    display: none;
  }

  .selection-table tr {
    /* 2. Make each row a card */
    display: block;
    border: 1px solid var(--tex-color-thirdly) !important;
    border-radius: 8px;
    margin-bottom: 1rem;
    padding: 0.5rem;
  }

  .selection-table td {
    /* 3. Make each cell a full-width row inside the card */
    display: flex;
    justify-content: space-between;
    /* Puts label on right, value on left */
    align-items: center;
    padding: 0.75rem 0.5rem;
    border-bottom: 1px solid #f0f0f0;
    text-align: left;
    /* Align data to the left */
    white-space: normal;
    /* Allow text to wrap */
    border-left: none !important;
  }

  .selection-table td:last-child {
    border-bottom: none !important;
  }

  .selection-table td::before {
    content: attr(data-label);
    /* Use the text from the data-label */
    font-weight: bold;
    color: var(--tex-color-thirdly) !important;
    padding-left: 1rem;
    text-align: right;
  }
}

.patient-option {
  padding: 8px 12px;
  border-bottom: 1px solid #f0f0f0;
}

.patient-option:hover {
  background-color: #f5f5f5;
}

.patient-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.file-number {
  font-size: 0.8em;
  color: #666;
  background: #f0f0f0;
  padding: 2px 6px;
  border-radius: 4px;
}

.patient-secondary {
  font-size: 0.8em;
  color: #888;
}

.national-code {
  direction: ltr;
  display: inline-block;
}

.selected-info {
  margin-top: 16px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}


.confirm-content {
  text-align: center;
  padding: 20px;
}

.confirm-buttons {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 20px;
}

.btn-confirm {
  background: #dc3545;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.btn-cancel {
  background: #6c757d;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>
